import { initializeVectorTileMap } from "../../components/mapViews/vectorTile/Map";
export function loadVectorTileMap(mapOptions) {
    mapOptions = {
        vectorTileURL: mapOptions.vectorTileURL,
        title: mapOptions.title,
        id: mapOptions.id,
        divContainer: mapOptions.divContainer,
        attributionControl: mapOptions.attributionControl,
        proxyURL: mapOptions.proxyURL,
        urlPrefix: mapOptions.urlPrefix,
        zoomControl: mapOptions.zoomControl,
        thumbnailUrl: mapOptions.thumbnailUrl,
        minScale: mapOptions.minScale,
        injectSecurityCode: mapOptions.injectSecurityCode
    };
    return initializeVectorTileMap(mapOptions);
}
